import { useNavigate, useLocation, useOutletContext } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { Col, Row, Button, Spin } from "antd";
import axios from "axios";
import moment from "moment";

import UserBar from "../../../layout/UserBar/UserBar";
import quotasSVG from "../../../assets/icons/quotas-verde.svg";
import quotasRedSVG from "../../../assets/icons/quotas-red.svg";
import quotasYellowSVG from "../../../assets/icons/quotas-amarelo.svg";
import legalSVG from "../../../assets/icons/Legal-Department.svg";
import ModalPaymentInfo from "../../../components/UserComponents/ModalPaymentInfo/ModalPaymentInfo";
import PaymentSteps from "../../../components/UserComponents/PaymentSteps/PaymentSteps";
import QuotesModal from "../../../components/UserComponents/QuotesModal/QuotesModal";
import ModalRegularization from "../../../components/UserComponents/ModalRegularization/ModalRegularization";
import endoinpts from "../../../utils/endoinpts";
import DashboardEvents from "../../../components/UserComponents/DashboardEvents/DashboardEvents";
import DashboardCertificates from "../../../components/UserComponents/DashboardCertificates/DashboardCertificates";
import DashboardListEvents from "../../../components/UserComponents/DashboardListEvents/DashboardListEvents";
import "./Home.css";
import dayjs from "dayjs";

function Home() {
  const { user } = useOutletContext();
  const { handleStopLoading } = useOutletContext();

  const [isPaymentNeeded, setIsPaymentNeeded] = useState(true);
  const [paymentRenovation, setPaymentRenovation] = useState(false);
  const [isWaitingForValidation, setIsWaitingForValidation] = useState(false);
  const [paymentWarning, setPaymentWarning] = useState(false);
  const [paymentOptions, setPaymentOptions] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isQuotesModalOpen, setIsQuotesModalOpen] = useState(false);
  const [payments, setPayments] = useState([]);
  const [isQuotesRegularization, setIsQuotesRegularization] = useState(false);
  const [showModalPaymentInfo, setShowModalPaymentInfo] = useState(false);

  const scrolledRef = useRef(false);
  const { hash } = useLocation();

  const navigate = useNavigate();

  useEffect(() => {
    if (user && Object.keys(user).length > 0) {
      handleGetUserInfo();
    }
  }, [user]);

  function handleGetUserInfo() {
    setIsLoading(true);
    axios
      .get(endoinpts.purchase.getPurchases, {
        params: { id_user: user.id },
      })
      .then((res) => {
        let paymentsData = res.data[0];

        user.quotes_regularization === 0 ? setIsQuotesRegularization(true) : setIsQuotesRegularization(false);

        if (user.payment_valid) {
          setIsWaitingForValidation(false);
          setIsPaymentNeeded(false);
        } else {
          if (paymentsData.length > 0) {
            if (paymentsData[0].status === "em validação" || paymentsData[0].status === "próximo pagamento") {
              setIsWaitingForValidation(true);
              setIsPaymentNeeded(false);
            } else if (paymentsData[0].status === "cancelado") {
              setIsWaitingForValidation(false);
              setIsPaymentNeeded(true);
            } else {
              setIsWaitingForValidation(false);
              setIsPaymentNeeded(true);
            }
          } else {
            setIsWaitingForValidation(false);
            setIsPaymentNeeded(true);
          }
        }

        setIsLoading(false);
        setPayments(paymentsData);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }

  function handlePayQuote() {
    setPaymentOptions(true);
  }

  function handleCloseQuotesRegularization() {
    setIsQuotesRegularization(false);
    handleGetUserInfo();
  }

  function handleClosePaymentSteps() {
    setPaymentOptions(false);
    handleGetUserInfo();
  }

  function handleUpdateUserInfo() {
    handleGetUserInfo();
  }

  function handleCloseQuotes() {
    setIsQuotesModalOpen(false);
    handleGetUserInfo();
  }

  return (
    <div className="w-full dashboard" ref={scrolledRef}>
      <div>
        <Spin spinning={isLoading}>
          <ModalRegularization user={user} show={isQuotesRegularization} close={() => handleCloseQuotesRegularization()} />
          <PaymentSteps user={user} open={paymentOptions} close={handleClosePaymentSteps} />
          <QuotesModal show={isQuotesModalOpen} close={handleCloseQuotes} payments={payments} user={user} handleUpdateUserInfo={handleUpdateUserInfo} />
          <div className="content">
            <ModalPaymentInfo show={showModalPaymentInfo} cancel={() => setShowModalPaymentInfo(false)} payment={payments[0]} />
            <div className="mt-[20px] grid grid-cols-3 gap-4">
              <div className="col-span-3 lg:col-span-1">
                <div className="dash_card flex flex-col">
                  <p className="dash_title mb-4">Gestão de Quotas</p>
                  <div className="flex flex-wrap lg:flex-nowrap">
                    <div className="mr-[20px]">
                      {isPaymentNeeded && <img src={quotasRedSVG} alt="quotas" className="min-w-[100px]" />}
                      {isWaitingForValidation && <img src={quotasYellowSVG} alt="quotas" className="min-w-[100px]" />}
                      {!isPaymentNeeded && !isWaitingForValidation && <img src={quotasSVG} alt="quotas" className="min-w-[100px]" />}
                    </div>
                    <div>
                      <p className="te4xt-[#4a4c4d] m-0 mb-2 font-[600]">
                        {isWaitingForValidation && "À espera"}
                        {isPaymentNeeded && "Em falta"}
                        {!isPaymentNeeded && !isWaitingForValidation && "Pago"}
                      </p>
                      <p className="text-[16px] m-0 text-[#bdbcbc]">
                        {isWaitingForValidation && !isPaymentNeeded && "À espera de pagamento"}
                        {isPaymentNeeded && !isWaitingForValidation && "Pagamento em falta"}
                        {!isPaymentNeeded && !isWaitingForValidation && moment(user.valid_access_date).format("DD-MM-YYYY")}
                      </p>
                      <div className="buttons_row mt-2">
                        {payments.length > 0 && <>{paymentRenovation && user.payment_method !== "debit" && <Button className="green_button mr-2 mt-[10px]">Renovar</Button>}</>}
                        {isWaitingForValidation && (
                          <div className="flex">
                            <Button className="button-yellow mr-2 mt-[10px]" onClick={() => setShowModalPaymentInfo(true)}>
                              Ver dados
                            </Button>
                            <Button className="transparent_button_yellow mt-[10px]" onClick={() => setIsQuotesModalOpen(true)}>
                              As minhas quotas
                            </Button>
                          </div>
                        )}
                        {isPaymentNeeded && (
                          <>
                            <Button type="primary" danger onClick={handlePayQuote} className="mr-2 mt-[10px]">
                              Efetuar pagamento
                            </Button>
                            {payments.length > 0 && (
                              <Button className={"transparent_button_red mt-[10px]"} onClick={() => setIsQuotesModalOpen(true)}>
                                As minhas quotas
                              </Button>
                            )}
                          </>
                        )}
                        {!isPaymentNeeded && !isWaitingForValidation && payments.length > 0 && (
                          <Button type="primary" onClick={() => setIsQuotesModalOpen(true)}>
                            As minhas quotas
                          </Button>
                        )}
                        {!isPaymentNeeded &&
                          !isWaitingForValidation &&
                          user.payment_method !== "debit" &&
                          user.payment_valid === 1 &&
                          dayjs(user.valid_access_date).diff(dayjs(), "day") < 15 && (
                            <Button variant="outlined" onClick={handlePayQuote} className="ml-[10px]!">
                              Efetuar pagamento
                            </Button>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="dash_card flex flex-col">
                  <p className="text-[#4a4c4d] dash_title mb-4">Formulário Departamento Jurídico</p>
                  <div className="flex flex-wrap lg:flex-nowrap">
                    <div className="mr-[20px]">
                      <img src={legalSVG} alt="quotas" className="min-w-[100px]" />
                    </div>
                    <div className="flex flex-col">
                      <p className="text-[#bdbcbc] mt-2 text-[14px]">Caso pretenda usufruir deste serviço, deve colocar as suas questões através deste formulário.</p>
                      <div className="buttons_row mt-[20px]">
                        {user?.payment_valid ? (
                          <Button className="grey_button mr-2" onClick={() => navigate(`/formulario`)}>
                            Formulário
                          </Button>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-span-3 lg:col-span-1">
                <DashboardEvents user={user} />
              </div>
              <div className="col-span-3 lg:col-span-1">
                <DashboardCertificates user={user} />
              </div>
            </div>
            <div id="eventos">
              <DashboardListEvents user={user} />
            </div>
          </div>
        </Spin>
      </div>
    </div>
  );
}

export default Home;
